module.exports = __webpack_public_path__ + "static/img/guanka.334bc622.png";